import { defineConstants } from "@p-ban/common/src/constants/defineConstants"

const SEMINAR_STATUS = defineConstants([
  { label: "作成中", value: "Making", isAccepting: false, isPublished: false },
  { label: "受付中", value: "Accepting", isAccepting: true, isPublished: true },
  { label: "受付終了", value: "AcceptEnd", isAccepting: false, isPublished: true },
  { label: "終了", value: "End", isAccepting: false, isPublished: true },
  { label: "中止", value: "Suspension", isAccepting: false, isPublished: false },
] as const)

export default SEMINAR_STATUS
